import { Stem, StemMatchTable } from "@examspark/types";

import { getNewScore } from "./utils";

export const scoreMatchTable = (
  expected: StemMatchTable,
  actual: Partial<Stem.Response>,
) => {
  const { scoring, content, config } = expected;
  const score = getNewScore();
  const rowCount = content.stems.length;
  let rowCountCorrect = 0;

  const isExactMatch =
    config?.enableCustomScoring &&
    config.matchTableGridScoringMethod === "EXACT";

  score.max = isExactMatch ? 1 : rowCount;
  if (!actual) return score;

  for (const stem of content.stems) {
    let correct = true;
    const selected: string[] = [];
    const keys: string[] = [];
    for (const opt of content.options) {
      if (actual.matchTable?.[stem.id]?.includes(opt.id)) {
        selected.push(opt.id);
      }

      if (scoring?.matchOptions?.[stem.id]?.[opt.id]?.isKey) {
        keys.push(opt.id);
      }
    }

    if (JSON.stringify(selected.sort()) !== JSON.stringify(keys.sort())) {
      correct = false;
    }

    if (correct) rowCountCorrect++;
  }

  if (isExactMatch) {
    if (rowCountCorrect === rowCount) {
      score.actual = 1;
    } else {
      score.actual = 0;
    }
  } else {
    score.actual = rowCountCorrect;
  }

  return score;
};
